module.exports = __webpack_public_path__ + "images/practice-exams-lms.jpg";